import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { SupplierQueryKeys } from './supplierQueryKeys';

export type DeleteSupplierPaymentVariables = {
    supplierId: string;
    paymentId: string;
};

/**
 * Withdraws a recorded payment (BOS-120). Same invalidation reach as recording
 * one — the balance moves either way.
 */
export const useDeleteSupplierPaymentMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<void>,
        Error,
        DeleteSupplierPaymentVariables
    >({
        mutationFn: ({ supplierId, paymentId }) =>
            apiClient.suppliers.deleteSupplierPayment(supplierId, paymentId),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: SupplierQueryKeys.all,
                });
            }
        },
    });
};
